query POTagsChartData {
  kpiPoTags {
    nodes {
      title
      amount
      linkSearchValue
    }
  }
}
